import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Sidebar from 'components/Sidebar'
import Conversations from 'components/messenger/Conversations'
import ChurchThreadPanel from 'components/messenger/churchThread/ChurchThreadPanel'
import { PageContainerMain } from 'pages/pages.styled'
import styled from 'styled-components'

export default function ChurchThread() {
  const navigate = useNavigate()
  const { user } = useSelector((state) => state.auth)
  useEffect(() => { if (!user) navigate('/login') }, [navigate, user])
  if (!user) return null
  return <PageContainerMain><Sidebar /><DesktopConversationList><Conversations /></DesktopConversationList><ChurchThreadPanel /></PageContainerMain>
}

const DesktopConversationList = styled.div`
  display: contents;
  @media (max-width: 768px) { display: none; }
`
